import Ammo from "ammojs-typed";
import { Point3D, Mesh3D } from "pixi3d";

type pointLike = {x?: number, y?: number, z?: number} | number | Point3D;
type quatLike = {x?: number, y?: number, z?: number, w?: number} | number;


export function vec3Arr(v: Ammo.btVector3) {
    return [v.x(), v.y(), v.z()];
}

export function quatArr(v: Ammo.btQuaternion) {
    return [v.x(), v.y(), v.z(), v.w()];
}

export function setVec3(vec: Ammo.btVector3, data: pointLike) {
    if (typeof data === `number`) {
        vec.setX(data);
        vec.setY(data);
        vec.setZ(data);
    } else {
        if (data.x !== undefined) {
            vec.setX(data.x);
        }
        if (data.y !== undefined) {
            vec.setY(data.y);
        }
        if (data.z !== undefined) {
            vec.setZ(data.z);
        }
    }
}

export function setQuat(quat: Ammo.btQuaternion, data: quatLike) {
    if (typeof data === `number`) {
        quat.setX(data);
        quat.setY(data);
        quat.setZ(data);
        quat.setW(1);
    } else {
        if (data.x !== undefined) {
            quat.setX(data.x);
        }
        if (data.y !== undefined) {
            quat.setY(data.y);
        }
        if (data.z !== undefined) {
            quat.setZ(data.z);
        }
        if (data.w !== undefined) {
            quat.setW(data.w);
        }
    }
}

export function setupCollider(shape: Ammo.btCollisionShape, mass: number, origin: pointLike, rotation: quatLike) {
    const transform = new Ammo.btTransform();
    transform.setIdentity();

    const originVec = new Ammo.btVector3(0, 0, 0);
    const rotationQuat = new Ammo.btQuaternion(0, 0, 0, 1);
    setVec3(originVec, origin);
    setQuat(rotationQuat, rotation);

    transform.setOrigin( originVec );
    transform.setRotation( rotationQuat );
    const motionState = new Ammo.btDefaultMotionState( transform );

    const localInertia = new Ammo.btVector3( 0, 0, 0 );
    shape.calculateLocalInertia( mass, localInertia );

    const rbInfo = new Ammo.btRigidBodyConstructionInfo( mass, motionState, shape, localInertia );
    const body = new Ammo.btRigidBody( rbInfo );

    return body;
}

export function asTriMesh(mesh: Mesh3D) {
    const indices = mesh.geometry.indices?.buffer as unknown as number[];
    const vertices = mesh.geometry.positions?.buffer as unknown as number[];
    const stride = 3;
    const triMesh = new Ammo.btTriangleMesh();
    for (let i = 0; i < indices.length * stride; i++)
    {
        const index0 = indices[i * stride + 2];
        const index1 = indices[i * stride + 1];
        const index2 = indices[i * stride + 0];
        const vertex0 = new Ammo.btVector3(vertices[index0 * stride + 0], vertices[index0 * stride + 1], vertices[index0 * stride + 2]);
        const vertex1 = new Ammo.btVector3(vertices[index1 * stride + 0], vertices[index1 * stride + 1], vertices[index1 * stride + 2]);
        const vertex2 = new Ammo.btVector3(vertices[index2 * stride + 0], vertices[index2 * stride + 1], vertices[index2 * stride + 2]);
        triMesh.addTriangle(vertex0, vertex1, vertex2);
    }

    return triMesh;
}